export const status = {
  created: 'created',
  onApprove: 'onApprove',
  rejected: 'rejected',
  approved: 'approved',
  excluded: 'excluded',
  dismissed: 'dismissed',
  prolongation: 'prolongation',
};

export const status_ru_m = {
  created: 'Новый',
  onApprove: 'На согласовании',
  rejected: 'Не согласован',
  approved: 'Принят',
  excluded: 'Исключен',
  dismissed: 'Уволен',
};

export const status_ru_f = {
  created: 'Новая',
  onApprove: 'На согласовании',
  rejected: 'Не согласована',
  approved: 'Принята',
};

export const status_ru_special = {
  created: 'Новый',
  onApprove: 'На согласовании',
  prolongation: 'Пролонгация',
  rejected: 'Не согласован',
  approved: 'Принят',
  excluded: 'Не относится к проекту',
};

export const status_full_m = {
  created: { key: status.created, label: status_ru_m.created, bg: 'secondary' },
  onApprove: { key: status.onApprove, label: status_ru_m.onApprove, bg: 'warning' },
  approved: { key: status.approved, label: status_ru_m.approved, bg: 'success' },
  rejected: { key: status.rejected, label: status_ru_m.rejected, bg: 'danger' },
  prolongation: { key: status.rejected, label: status_ru_m.rejected, bg: 'danger' },
  excluded: { key: status.excluded, label: status_ru_m.excluded, bg: 'danger' },
  dismissed: { key: status.dismissed, label: status_ru_m.dismissed, bg: 'danger' },
};

export const status_full_f = {
  created: { key: status.created, label: status_ru_f.created, bg: 'secondary' },
  onApprove: { key: status.onApprove, label: status_ru_f.onApprove, bg: 'warning' },
  approved: { key: status.approved, label: status_ru_f.approved, bg: 'success' },
  rejected: { key: status.rejected, label: status_ru_f.rejected, bg: 'danger' },
};

export const status_full_special = {
  created: { key: status.created, label: status_ru_special.created, bg: 'secondary' },
  onApprove: { key: status.onApprove, label: status_ru_special.onApprove, bg: 'warning' },
  prolongation: { key: status.prolongation, label: status_ru_special.prolongation, bg: 'primary' },
  approved: { key: status.approved, label: status_ru_special.approved, bg: 'success' },
  rejected: { key: status.rejected, label: status_ru_special.rejected, bg: 'danger' },
  excluded: { key: status.excluded, label: status_ru_special.excluded, bg: 'danger' },
};

export const roles = {
  head: 'Руководитель проекта',
  admin: 'Администратор проекта',
  participantAdmin: 'Участник с правами администратора',
  participant: 'Участник',
};

